/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ModalProgressBar } from '../../../../../../_metronic/_partials/controls';
import * as actions from '../../../_redux/products/productsActions';
import { useProductsUIContext } from '../ProductsUIContext';

export function ProductDeleteDialog({ id, show, onHide }) {
  const productsUIContext = useProductsUIContext();
  const productsUIProps = useMemo(() => {
    return {
      setIds: productsUIContext.setIds,
      queryParams: productsUIContext.queryParams,
    };
  }, [productsUIContext]);

  // Products Redux state
  const dispatch = useDispatch();
  const intl = useIntl();
  const titleText = intl.formatMessage({ id: 'PRODUCT.CONFIRM.TITLE' });
  const questionText = intl.formatMessage({
    id: 'PRODUCT.CONFIRM.DELETE.QUESTION',
  });
  const deleteButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.DELETE',
  });
  const cancelButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.CANCEL',
  });
  const loadingText = intl.formatMessage({
    id: 'PRODUCT.CONFIRM.DELETE.LOADING',
  });
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.products ? state.products.actionsLoading : false,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!id) {
      onHide();
    }
  }, [id]);

  useEffect(() => {}, [isLoading, dispatch]);

  const deleteProduct = () => {
    dispatch(actions.deleteProduct(id)).then(() => {
      dispatch(actions.fetchProducts(productsUIProps.queryParams));
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      {isLoading && <ModalProgressBar variant='query' />}
      <Modal.Header closeButton>
        <Modal.Title id='Productexample-modal-sizes-title-lg'>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>
            {' '}
            <b>{id}</b> {questionText}
          </span>
        )}
        {isLoading && <span>{loadingText}</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'
          >
            {cancelButtonText}
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteProduct}
            className='btn btn-primary btn-elevate'
          >
            {deleteButtonText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
